<template>
  <div v-if="initiated" class="admin">
    <Menu />
    <h3>
      Modération Photos <span v-if="pictures">({{ pictures.length }} photos à modérer)</span>
    </h3>
    <div class="conteneurModeration">
      <div v-for="pic in pictures" :key="pic.id" class="modItem">
        <div class="conteneurCadre">
          <div class="cadrePhoto">
            <ConnectedIcon :profile="pic.profile" />
            <Photo :pic="pic" :profile="pic.profile" />
          </div>
          <div class="photoIP">
            <PhotoDetail :prf="pic.profile" :usr="pic.user">
              <InfosIp :prf="pic.profile" :usr="pic.user" :sniped="pic.sniped" />
            </PhotoDetail>

            <span class="brout" v-if="pic.profile.suspect"
              >Ce profil a été détecté comme "brouteur" et sera nettoyé</span
            >

            <span v-html="passName(pic.user.pass.permission)" />
          </div>
        </div>
        <div class="actions">
          <button class="bouton" @click="validateProfile(pic.id)">
            <img src="/assets/icons/check.png" /> Portrait
          </button>
          <button class="bouton" @click="validateAlbum(pic.id)"><img src="/assets/icons/check.png" /> Album</button>
          <button class="bouton" @click="refusePicture(pic.id)"><img src="/assets/icons/cross.png" /> Refuser</button>
          <button class="bouton" @click="verify(pic.idProfile)"><img src="/assets/icons/eyes.png" /> Vérifier</button>
          <button class="bouton" @click="kickProfile(pic.profile.pseudo)">
            <img src="/assets/smiley/angry.png" /> Kicker
          </button>
          <button class="bouton" @click="banProfile(pic.profile.id)">
            <img src="/assets/smiley/angry2.png" /> Bannir
          </button>
          <button class="bouton" disabled><img src="/assets/icons/bulle.png" /> Chat Log</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
import BasePage from "@/components/pages/BasePage";
import Photo from "@/components/profile/Photo";
import ConnectedIcon from "@/components/profile/ConnectedIcon";

import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import InfosIp from "@/components/admin/InfosIp.vue";
import PhotoDetail from "@/components/admin/PhotoDetail.vue";
import { idyuGetPassNameFromPermission } from "../../assets/js/idyu/util";

export default {
  name: "AdminPhotos",
  components: { Menu, Photo, ConnectedIcon, InfosIp, PhotoDetail },
  extends: BasePage,
  data() {
    return { pictures: null };
  },
  methods: {
    async init() {
      this.pictures = await idyuJsonRpc("getPicturesToValidate");
      for (let pic of this.pictures) {
        let profile = await idyuJsonRpc("getProfileSummary", pic.idProfile);
        let sniped = await idyuJsonRpc("getSnipedProfile", pic.idProfile);
        let user = await idyuJsonRpc("getUser", pic.idProfile);
        this.$set(pic, "profile", profile);
        this.$set(pic, "sniped", sniped);
        this.$set(pic, "user", user);
      }
    },

    removePicture(idPic) {
      let index = this.pictures.findIndex(elt => elt.id == idPic);
      if (index != -1) {
        this.pictures.splice(index, 1);
      }
    },

    removeIdProfile(idProfile) {
      this.pictures = this.pictures.filter(elt => elt.profile.id != idProfile);
    },

    removePseudo(pseudo) {
      this.pictures = this.pictures.filter(elt => elt.profile.pseudo != pseudo);
    },

    validateProfile(idPic) {
      idyuJsonRpc("validatePicture", idPic, 0);
      this.removePicture(idPic);
    },

    validateAlbum(idPic) {
      idyuJsonRpc("validatePicture", idPic, 1);
      this.removePicture(idPic);
    },

    refusePicture(idPic) {
      idyuJsonRpc("refusePicture", idPic);
      this.removePicture(idPic);
    },

    kickProfile(pseudo) {
      idyuJsonRpc("kickProfile", pseudo);
      this.removePseudo(pseudo);
    },

    banProfile(idProfile) {
      idyuJsonRpc("banProfile", idProfile);
      this.removeIdProfile(idProfile);
    },

    verify(idProfile) {
      this.$router.push({ name: "AdminUsers", query: { id: idProfile } });
    },

    passName(perm) {
      return idyuGetPassNameFromPermission(perm);
    }
  }
};
</script>

<style scoped>
.conteneurModeration {
  display: grid;
  grid-gap: 10px;
  align-items: baseline;
  grid-auto-rows: min-content;
}

.conteneurCadre {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  justify-content: left;
}

.modItem {
  border-bottom: 1px #555 dotted;
  padding-bottom: 10px;
}

.photoIP {
  display: grid;
  grid-gap: 5px;
  align-items: baseline;
  grid-auto-rows: min-content;
}

.actions {
  margin-top: 10px;
  display: flex;
}

.actions button {
  margin-right: 10px;
  min-width: 120px;
}

button img {
  margin-right: 10px;
}

.brout {
  font-style: italic;
  color: rgb(153, 99, 0);
}
</style>
